import type { ComponentProps, ReactNode } from 'react';

import {
  button,
  buttonInner,
  buttonLabel,
  buttonLoader,
  buttonSection,
} from '@mage-ui/styled-system/recipes';
import { Button as MantineButton } from '@mantine/core';

export type ButtonProps = ComponentProps<'button'> & {
  classNames?: {
    root?: string;
    inner?: string;
    label?: string;
    section?: string;
    loader?: string;
  };
  startSlot?: ReactNode;
  endSlot?: ReactNode;
  children?: ReactNode;
  component?: 'button' | 'span';
  loading?: boolean;
};

export const Button = ({
  classNames,
  startSlot,
  endSlot,
  children,
  ...props
}: ButtonProps) => {
  return (
    <MantineButton
      classNames={{
        root: classNames?.root ?? button(),
        inner: classNames?.inner ?? buttonInner(),
        label: classNames?.label ?? buttonLabel(),
        section: classNames?.section ?? buttonSection(),
        loader: classNames?.loader ?? buttonLoader(),
      }}
      leftSection={startSlot}
      rightSection={endSlot}
      {...props}
    >
      {children}
    </MantineButton>
  );
};
